<template>
<div class="chapter">
<div class="inner_page">
<p class="image" id="page_xii"><img alt="image" src="html/images/f0xii-01.jpg"/></p>
<p class="caption"><em>Map by Alma López</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292799325_10_img.vue?56e1fada